'use client';
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;

var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};

var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
        _step;

    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return to;
};

var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
}; // src/index.ts


var src_exports = {};

__export(src_exports, {
  Toast: function Toast() {
    return _Toast;
  },
  ToastOptionProvider: function ToastOptionProvider() {
    return _ToastOptionProvider;
  },
  ToastProvider: function ToastProvider() {
    return _ToastProvider;
  },
  createRenderToast: function createRenderToast() {
    return _createRenderToast;
  },
  createStandaloneToast: function createStandaloneToast() {
    return _createStandaloneToast;
  },
  createToastFn: function createToastFn() {
    return _createToastFn;
  },
  getToastPlacement: function getToastPlacement() {
    return _getToastPlacement;
  },
  useToast: function useToast() {
    return _useToast;
  }
});

module.exports = __toCommonJS(src_exports); // src/use-toast.tsx

var import_system3 = require("@chakra-ui/system"); // src/toast.tsx


var import_alert = require("@chakra-ui/alert");

var import_system = require("@chakra-ui/system");

var import_close_button = require("@chakra-ui/close-button");

var import_shared_utils = require("@chakra-ui/shared-utils"); // src/toast.placement.ts


function _getToastPlacement(position, dir) {
  var _a;

  var computedPosition = position != null ? position : "bottom";
  var logicals = {
    "top-start": {
      ltr: "top-left",
      rtl: "top-right"
    },
    "top-end": {
      ltr: "top-right",
      rtl: "top-left"
    },
    "bottom-start": {
      ltr: "bottom-left",
      rtl: "bottom-right"
    },
    "bottom-end": {
      ltr: "bottom-right",
      rtl: "bottom-left"
    }
  };
  var logical = logicals[computedPosition];
  return (_a = logical == null ? void 0 : logical[dir]) != null ? _a : computedPosition;
} // src/toast.utils.ts


var findById = function findById(arr, id) {
  return arr.find(function (toast) {
    return toast.id === id;
  });
};

function findToast(toasts, id) {
  var position = getToastPosition(toasts, id);
  var index = position ? toasts[position].findIndex(function (toast) {
    return toast.id === id;
  }) : -1;
  return {
    position: position,
    index: index
  };
}

function getToastPosition(toasts, id) {
  for (var _i = 0, _Object$entries = Object.entries(toasts); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        position = _Object$entries$_i[0],
        values = _Object$entries$_i[1];

    if (findById(values, id)) {
      return position;
    }
  }
}

function getToastStyle(position) {
  var isRighty = position.includes("right");
  var isLefty = position.includes("left");
  var alignItems = "center";
  if (isRighty) alignItems = "flex-end";
  if (isLefty) alignItems = "flex-start";
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: alignItems
  };
}

function getToastListStyle(position) {
  var isTopOrBottom = position === "top" || position === "bottom";
  var margin = isTopOrBottom ? "0 auto" : void 0;
  var top = position.includes("top") ? "env(safe-area-inset-top, 0px)" : void 0;
  var bottom = position.includes("bottom") ? "env(safe-area-inset-bottom, 0px)" : void 0;
  var right = !position.includes("left") ? "env(safe-area-inset-right, 0px)" : void 0;
  var left = !position.includes("right") ? "env(safe-area-inset-left, 0px)" : void 0;
  return {
    position: "fixed",
    zIndex: "var(--toast-z-index, 5500)",
    pointerEvents: "none",
    display: "flex",
    flexDirection: "column",
    margin: margin,
    top: top,
    bottom: bottom,
    right: right,
    left: left
  };
} // src/toast.store.ts


var initialState = {
  top: [],
  "top-left": [],
  "top-right": [],
  "bottom-left": [],
  bottom: [],
  "bottom-right": []
};
var toastStore = createStore(initialState);

function createStore(initialState2) {
  var state = initialState2;
  var listeners = /* @__PURE__ */new Set();

  var setState = function setState(setStateFn) {
    state = setStateFn(state);
    listeners.forEach(function (l) {
      return l();
    });
  };

  return {
    getState: function getState() {
      return state;
    },
    subscribe: function subscribe(listener) {
      listeners.add(listener);
      return function () {
        setState(function () {
          return initialState2;
        });
        listeners.delete(listener);
      };
    },

    /**
     * Delete a toast record at its position
     */
    removeToast: function removeToast(id, position) {
      setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, position, prevState[position].filter(function (toast) {
          return toast.id != id;
        })));
      });
    },
    notify: function notify(message, options) {
      var toast = createToast(message, options);
      var position = toast.position,
          id = toast.id;
      setState(function (prevToasts) {
        var _a, _b;

        var isTop = position.includes("top");
        var toasts = isTop ? [toast].concat(_toConsumableArray((_a = prevToasts[position]) != null ? _a : [])) : [].concat(_toConsumableArray((_b = prevToasts[position]) != null ? _b : []), [toast]);
        return _objectSpread(_objectSpread({}, prevToasts), {}, _defineProperty({}, position, toasts));
      });
      return id;
    },
    update: function update(id, options) {
      if (!id) return;
      setState(function (prevState) {
        var nextState = _objectSpread({}, prevState);

        var _findToast = findToast(nextState, id),
            position = _findToast.position,
            index = _findToast.index;

        if (position && index !== -1) {
          nextState[position][index] = _objectSpread(_objectSpread(_objectSpread({}, nextState[position][index]), options), {}, {
            message: _createRenderToast(options)
          });
        }

        return nextState;
      });
    },
    closeAll: function closeAll() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          positions = _ref.positions;

      setState(function (prev) {
        var allPositions = ["bottom", "bottom-right", "bottom-left", "top", "top-left", "top-right"];
        var positionsToClose = positions != null ? positions : allPositions;
        return positionsToClose.reduce(function (acc, position) {
          acc[position] = prev[position].map(function (toast) {
            return _objectSpread(_objectSpread({}, toast), {}, {
              requestClose: true
            });
          });
          return acc;
        }, _objectSpread({}, prev));
      });
    },
    close: function close(id) {
      setState(function (prevState) {
        var position = getToastPosition(prevState, id);
        if (!position) return prevState;
        return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, position, prevState[position].map(function (toast) {
          if (toast.id == id) {
            return _objectSpread(_objectSpread({}, toast), {}, {
              requestClose: true
            });
          }

          return toast;
        })));
      });
    },
    isActive: function isActive(id) {
      return Boolean(findToast(toastStore.getState(), id).position);
    }
  };
}

var counter = 0;

function createToast(message) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _a, _b;

  counter += 1;
  var id = (_a = options.id) != null ? _a : counter;
  var position = (_b = options.position) != null ? _b : "bottom";
  return {
    id: id,
    message: message,
    position: position,
    duration: options.duration,
    onCloseComplete: options.onCloseComplete,
    onRequestRemove: function onRequestRemove() {
      return toastStore.removeToast(String(id), position);
    },
    status: options.status,
    requestClose: false,
    containerStyle: options.containerStyle
  };
} // src/toast.tsx


var import_jsx_runtime = require("react/jsx-runtime");

var _Toast = function _Toast(props) {
  var status = props.status,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? "solid" : _props$variant,
      id = props.id,
      title = props.title,
      isClosable = props.isClosable,
      onClose = props.onClose,
      description = props.description,
      colorScheme = props.colorScheme,
      icon = props.icon;
  var ids = id ? {
    root: "toast-".concat(id),
    title: "toast-".concat(id, "-title"),
    description: "toast-".concat(id, "-description")
  } : void 0;
  return /* @__PURE__ */(0, import_jsx_runtime.jsxs)(import_alert.Alert, {
    addRole: false,
    status: status,
    variant: variant,
    id: ids == null ? void 0 : ids.root,
    alignItems: "start",
    borderRadius: "md",
    boxShadow: "lg",
    paddingEnd: 8,
    textAlign: "start",
    width: "auto",
    colorScheme: colorScheme,
    children: [/* @__PURE__ */(0, import_jsx_runtime.jsx)(import_alert.AlertIcon, {
      children: icon
    }), /* @__PURE__ */(0, import_jsx_runtime.jsxs)(import_system.chakra.div, {
      flex: "1",
      maxWidth: "100%",
      children: [title && /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_alert.AlertTitle, {
        id: ids == null ? void 0 : ids.title,
        children: title
      }), description && /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_alert.AlertDescription, {
        id: ids == null ? void 0 : ids.description,
        display: "block",
        children: description
      })]
    }), isClosable && /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_close_button.CloseButton, {
      size: "sm",
      onClick: onClose,
      position: "absolute",
      insetEnd: 1,
      top: 1
    })]
  });
};

function _createRenderToast() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var render = options.render,
      _options$toastCompone = options.toastComponent,
      ToastComponent2 = _options$toastCompone === void 0 ? _Toast : _options$toastCompone;

  var renderToast = function renderToast(props) {
    if (typeof render === "function") {
      return render(_objectSpread(_objectSpread({}, props), options));
    }

    return /* @__PURE__ */(0, import_jsx_runtime.jsx)(ToastComponent2, _objectSpread(_objectSpread({}, props), options));
  };

  return renderToast;
}

function _createToastFn(dir, defaultOptions) {
  var normalizeToastOptions = function normalizeToastOptions(options) {
    var _a;

    return _objectSpread(_objectSpread(_objectSpread({}, defaultOptions), options), {}, {
      position: _getToastPlacement((_a = options == null ? void 0 : options.position) != null ? _a : defaultOptions == null ? void 0 : defaultOptions.position, dir)
    });
  };

  var toast = function toast(options) {
    var normalizedToastOptions = normalizeToastOptions(options);

    var Message = _createRenderToast(normalizedToastOptions);

    return toastStore.notify(Message, normalizedToastOptions);
  };

  toast.update = function (id, options) {
    toastStore.update(id, normalizeToastOptions(options));
  };

  toast.promise = function (promise, options) {
    var id = toast(_objectSpread(_objectSpread({}, options.loading), {}, {
      status: "loading",
      duration: null
    }));
    promise.then(function (data) {
      return toast.update(id, _objectSpread({
        status: "success",
        duration: 5e3
      }, (0, import_shared_utils.runIfFn)(options.success, data)));
    }).catch(function (error) {
      return toast.update(id, _objectSpread({
        status: "error",
        duration: 5e3
      }, (0, import_shared_utils.runIfFn)(options.error, error)));
    });
  };

  toast.closeAll = toastStore.closeAll;
  toast.close = toastStore.close;
  toast.isActive = toastStore.isActive;
  return toast;
} // src/use-toast.tsx


var import_react3 = require("react"); // src/toast.provider.tsx


var import_framer_motion2 = require("framer-motion");

var import_portal = require("@chakra-ui/portal"); // src/toast.component.tsx


var import_react_use_timeout = require("@chakra-ui/react-use-timeout");

var import_react_use_update_effect = require("@chakra-ui/react-use-update-effect");

var import_shared_utils2 = require("@chakra-ui/shared-utils");

var import_framer_motion = require("framer-motion");

var import_system2 = require("@chakra-ui/system");

var import_react = require("react");

var import_jsx_runtime2 = require("react/jsx-runtime");

var toastMotionVariants = {
  initial: function initial(props) {
    var position = props.position;
    var dir = ["top", "bottom"].includes(position) ? "y" : "x";
    var factor = ["top-right", "bottom-right"].includes(position) ? 1 : -1;
    if (position === "bottom") factor = 1;
    return _defineProperty({
      opacity: 0
    }, dir, factor * 24);
  },
  animate: {
    opacity: 1,
    y: 0,
    x: 0,
    scale: 1,
    transition: {
      duration: 0.4,
      ease: [0.4, 0, 0.2, 1]
    }
  },
  exit: {
    opacity: 0,
    scale: 0.85,
    transition: {
      duration: 0.2,
      ease: [0.4, 0, 1, 1]
    }
  }
};
var ToastComponent = (0, import_react.memo)(function (props) {
  var id = props.id,
      message = props.message,
      onCloseComplete = props.onCloseComplete,
      onRequestRemove = props.onRequestRemove,
      _props$requestClose = props.requestClose,
      requestClose = _props$requestClose === void 0 ? false : _props$requestClose,
      _props$position = props.position,
      position = _props$position === void 0 ? "bottom" : _props$position,
      _props$duration = props.duration,
      duration = _props$duration === void 0 ? 5e3 : _props$duration,
      containerStyle = props.containerStyle,
      _props$motionVariants = props.motionVariants,
      motionVariants = _props$motionVariants === void 0 ? toastMotionVariants : _props$motionVariants,
      _props$toastSpacing = props.toastSpacing,
      toastSpacing = _props$toastSpacing === void 0 ? "0.5rem" : _props$toastSpacing;

  var _ref3 = (0, import_react.useState)(duration),
      _ref4 = _slicedToArray(_ref3, 2),
      delay = _ref4[0],
      setDelay = _ref4[1];

  var isPresent = (0, import_framer_motion.useIsPresent)();
  (0, import_react_use_update_effect.useUpdateEffect)(function () {
    if (!isPresent) {
      onCloseComplete == null ? void 0 : onCloseComplete();
    }
  }, [isPresent]);
  (0, import_react_use_update_effect.useUpdateEffect)(function () {
    setDelay(duration);
  }, [duration]);

  var onMouseEnter = function onMouseEnter() {
    return setDelay(null);
  };

  var onMouseLeave = function onMouseLeave() {
    return setDelay(duration);
  };

  var close = function close() {
    if (isPresent) onRequestRemove();
  };

  (0, import_react.useEffect)(function () {
    if (isPresent && requestClose) {
      onRequestRemove();
    }
  }, [isPresent, requestClose, onRequestRemove]);
  (0, import_react_use_timeout.useTimeout)(close, delay);
  var containerStyles = (0, import_react.useMemo)(function () {
    return _objectSpread({
      pointerEvents: "auto",
      maxWidth: 560,
      minWidth: 300,
      margin: toastSpacing
    }, containerStyle);
  }, [containerStyle, toastSpacing]);
  var toastStyle = (0, import_react.useMemo)(function () {
    return getToastStyle(position);
  }, [position]);
  return /* @__PURE__ */(0, import_jsx_runtime2.jsx)(import_framer_motion.motion.div, {
    layout: true,
    className: "chakra-toast",
    variants: motionVariants,
    initial: "initial",
    animate: "animate",
    exit: "exit",
    onHoverStart: onMouseEnter,
    onHoverEnd: onMouseLeave,
    custom: {
      position: position
    },
    style: toastStyle,
    children: /* @__PURE__ */(0, import_jsx_runtime2.jsx)(import_system2.chakra.div, {
      role: "status",
      "aria-atomic": "true",
      className: "chakra-toast__inner",
      __css: containerStyles,
      children: (0, import_shared_utils2.runIfFn)(message, {
        id: id,
        onClose: close
      })
    })
  });
});
ToastComponent.displayName = "ToastComponent"; // src/toast.provider.tsx

var import_react2 = require("react");

var import_react_context = require("@chakra-ui/react-context");

var import_jsx_runtime3 = require("react/jsx-runtime");

var _ref5 = (0, import_react_context.createContext)({
  name: "ToastOptionsContext",
  strict: false
}),
    _ref6 = _slicedToArray(_ref5, 2),
    _ToastOptionProvider = _ref6[0],
    useToastOptionContext = _ref6[1];

var _ToastProvider = function _ToastProvider(props) {
  var state = (0, import_react2.useSyncExternalStore)(toastStore.subscribe, toastStore.getState, toastStore.getState);
  var motionVariants = props.motionVariants,
      _props$component = props.component,
      Component = _props$component === void 0 ? ToastComponent : _props$component,
      portalProps = props.portalProps;
  var stateKeys = Object.keys(state);
  var toastList = stateKeys.map(function (position) {
    var toasts = state[position];
    return /* @__PURE__ */(0, import_jsx_runtime3.jsx)("div", {
      role: "region",
      "aria-live": "polite",
      "aria-label": "Notifications-".concat(position),
      id: "chakra-toast-manager-".concat(position),
      style: getToastListStyle(position),
      children: /* @__PURE__ */(0, import_jsx_runtime3.jsx)(import_framer_motion2.AnimatePresence, {
        initial: false,
        children: toasts.map(function (toast) {
          return /* @__PURE__ */(0, import_jsx_runtime3.jsx)(Component, _objectSpread({
            motionVariants: motionVariants
          }, toast), toast.id);
        })
      })
    }, position);
  });
  return /* @__PURE__ */(0, import_jsx_runtime3.jsx)(import_portal.Portal, _objectSpread(_objectSpread({}, portalProps), {}, {
    children: toastList
  }));
}; // src/use-toast.tsx


function _useToast(options) {
  var _ref7 = (0, import_system3.useChakra)(),
      theme = _ref7.theme;

  var defaultOptions = useToastOptionContext();
  return (0, import_react3.useMemo)(function () {
    return _createToastFn(theme.direction, _objectSpread(_objectSpread({}, defaultOptions), options));
  }, [options, theme.direction, defaultOptions]);
} // src/create-standalone-toast.tsx


var import_system4 = require("@chakra-ui/system");

var import_theme = require("@chakra-ui/theme");

var import_jsx_runtime4 = require("react/jsx-runtime");

var defaults = {
  duration: 5e3,
  variant: "solid"
};
var defaultStandaloneParam = {
  theme: import_theme.theme,
  colorMode: "light",
  toggleColorMode: function toggleColorMode() {},
  setColorMode: function setColorMode() {},
  defaultOptions: defaults,
  forced: false
};

function _createStandaloneToast() {
  var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultStandaloneParam,
      _ref8$theme = _ref8.theme,
      theme = _ref8$theme === void 0 ? defaultStandaloneParam.theme : _ref8$theme,
      _ref8$colorMode = _ref8.colorMode,
      colorMode = _ref8$colorMode === void 0 ? defaultStandaloneParam.colorMode : _ref8$colorMode,
      _ref8$toggleColorMode = _ref8.toggleColorMode,
      toggleColorMode = _ref8$toggleColorMode === void 0 ? defaultStandaloneParam.toggleColorMode : _ref8$toggleColorMode,
      _ref8$setColorMode = _ref8.setColorMode,
      setColorMode = _ref8$setColorMode === void 0 ? defaultStandaloneParam.setColorMode : _ref8$setColorMode,
      _ref8$defaultOptions = _ref8.defaultOptions,
      defaultOptions = _ref8$defaultOptions === void 0 ? defaultStandaloneParam.defaultOptions : _ref8$defaultOptions,
      motionVariants = _ref8.motionVariants,
      toastSpacing = _ref8.toastSpacing,
      component = _ref8.component,
      forced = _ref8.forced;

  var colorModeContextValue = {
    colorMode: colorMode,
    setColorMode: setColorMode,
    toggleColorMode: toggleColorMode,
    forced: forced
  };

  var ToastContainer = function ToastContainer() {
    return /* @__PURE__ */(0, import_jsx_runtime4.jsx)(import_system4.ThemeProvider, {
      theme: theme,
      children: /* @__PURE__ */(0, import_jsx_runtime4.jsx)(import_system4.ColorModeContext.Provider, {
        value: colorModeContextValue,
        children: /* @__PURE__ */(0, import_jsx_runtime4.jsx)(_ToastProvider, {
          defaultOptions: defaultOptions,
          motionVariants: motionVariants,
          toastSpacing: toastSpacing,
          component: component
        })
      })
    });
  };

  return {
    ToastContainer: ToastContainer,
    toast: _createToastFn(theme.direction, defaultOptions)
  };
} // Annotate the CommonJS export names for ESM import in node:


0 && (module.exports = {
  Toast: _Toast,
  ToastOptionProvider: _ToastOptionProvider,
  ToastProvider: _ToastProvider,
  createRenderToast: _createRenderToast,
  createStandaloneToast: _createStandaloneToast,
  createToastFn: _createToastFn,
  getToastPlacement: _getToastPlacement,
  useToast: _useToast
});